import axios from "axios";

const privateApi = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  withCredentials: true,
});

privateApi.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      sessionStorage.setItem("isSessionExpired", "1");
      window.location.href = "/login";
    }
    if (
      err.response?.status === 503 &&
      err.response?.data?.code === "MAINTENANCE_LOGIN_RESTRICTED"
    ) {
      window.location.href = "/login";
    }
    // エラーを再スローして、元のPromiseがrejectされるようにする
    throw err;
  }
);

const publicApi = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  withCredentials: true,
});

export { privateApi, publicApi };
